import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import Login from "./Login";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { signOut } from "firebase/auth";
function LoginPage() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(true);
      } else {
        setUser(null);
      }
    });
  }, []);

  const click = () => {
    signOut(auth).then(() => alert("signout successful"));
  };
  return (
    <div className="App">
      {!user ? <Login /> : <button onClick={click}>signout</button>}
    </div>
  );
}

export default LoginPage;
